import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { messagesService } from '../services/api';

/**
 * Global mesaj bildirim sistemi
 * Tüm sayfalarda çalışır, yeni mesaj geldiğinde bildirim gösterir
 */
export const useGlobalMessageNotifications = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isMessagesPage = location.pathname === '/messages';
  const lastCheckRef = useRef(null);
  const unreadCountsRef = useRef({});

  useEffect(() => {
    // Mesajlar sayfasındaysa global bildirim gösterme (sayfa kendi bildirimini gösterir)
    if (isMessagesPage) {
      return;
    }

    // Her 15 saniyede bir yeni mesajları kontrol et
    const checkInterval = setInterval(async () => {
      try {
        const response = await messagesService.getMessages({
          channel: 'whatsapp',
          page: 1,
          limit: 50,
          archived: 0,
          deleted: 0
        });

        if (response.success && response.data) {
          const conversations = response.data || [];
          
          // Her kanal için okunmamış mesaj sayısını kontrol et
          conversations.forEach(conv => {
            const channel = 'whatsapp'; // Şimdilik sadece WhatsApp
            const currentUnread = conv.unread_count || 0;
            const previousUnread = unreadCountsRef.current[channel] || 0;

            // Yeni okunmamış mesaj var mı?
            if (currentUnread > previousUnread) {
              const newUnread = currentUnread - previousUnread;
              const channelName = 'WhatsApp';
              
              // Bildirim göster
              toast.info(`${channelName}: ${newUnread} yeni mesaj`, {
                onClick: () => {
                  navigate('/messages');
                },
                autoClose: 5000
              });
            }

            // Güncel okunmamış sayısını kaydet
            unreadCountsRef.current[channel] = currentUnread;
          });
        }
      } catch (error) {
        // Sessizce hata yut, polling devam etsin
        console.error('Global message notification error:', error);
      }
    }, 15000); // 15 saniyede bir kontrol et

    return () => {
      clearInterval(checkInterval);
    };
  }, [isMessagesPage, navigate]);
};

